import { SERVER_URL } from "Static/constant";

// Account logos: the stored logo, then the site's own icon from Salesgear's image service
// (/cm/img/logo/<domain>, which answers 404 when the site has no real icon), then the caller's initial.
// Every URL here is a Salesgear one: vendor image URLs are rewritten server-side before they reach us.

export const faviconUrl = domain => {
  const host = String(domain || "").trim().replace(/^https?:\/\//, "").replace(/\/.*$/, "");
  return host ? `${SERVER_URL}/cm/img/logo/${encodeURIComponent(host)}` : "";
};

// The URLs to try, in order.
export const logoCandidates = (logo, domain) => [logo, faviconUrl(domain)].filter(Boolean);

export const accountLogoUrl = (logo, domain) => logoCandidates(logo, domain)[0] || "";

// A tiny generic icon counts as no logo.
export const isPlaceholderIcon = img => Boolean(img) && img.naturalWidth > 0 && img.naturalWidth <= 16;
